var JobSearch_1;
import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { componentStyles } from './job-search.css.js';
let JobSearch = JobSearch_1 = class JobSearch extends LitElement {
    render() {
        return html `
      <div>
        <h3>${JobSearch_1.uiStrings.formHeadline}</h3>
        <form @submit=${this._onFormSubmission}>
          <input type="search" .placeholder=${JobSearch_1.uiStrings.searchPlaceholder} />
          <span class="input-leading-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-xds="IconSearch" width="24" height="24">
              <path d="M12 2a9 9 0 016.568 15.154l3.089 3.089-1.414 1.414-3.201-3.2A9 9 0 1112 2zm0 2a7 7 0 100 14 7 7 0 000-14z" fill="currentColor"></path>
            </svg>
          </span>
          <button type="submit">${JobSearch_1.uiStrings.submitButton}</button>
        </form>
      </div>
    `;
    }
    _onFormSubmission(event) {
        event.preventDefault();
        const searchField = this.shadowRoot.querySelector('input[type="search"]');
        const searchTerm = searchField.value;
        // We actually have something in the search field
        if (searchTerm !== '') {
            const searchUrl = new URL('https://www.xing.com/jobs/search');
            searchUrl.searchParams.set('sc_o', 'xing_lp_find_jobs_banner');
            searchUrl.searchParams.set('sc_o_PropActionOrigin', 'xing_lp_ballerleague');
            searchUrl.searchParams.set('keywords', searchTerm);
            // Reset the search field
            searchField.value = '';
            // Redirect them to the search results
            window.location.assign(searchUrl.href);
        }
    }
};
JobSearch.styles = componentStyles;
JobSearch.uiStrings = {
    formHeadline: 'Falls es mit dem Profi-Fußball doch nichts wird - hier sind 1 Mio. Alternativen:',
    searchPlaceholder: 'Job-Titel eingeben',
    submitButton: 'Jobs finden',
};
JobSearch = JobSearch_1 = __decorate([
    customElement('job-search')
], JobSearch);
export { JobSearch };
//# sourceMappingURL=job-search.js.map